import React, { useEffect } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';

import { Link, useNavigate } from 'react-router-dom';
import { API_URL } from '..';

const SignUpUserTable = ({jobsData,status}) => {
    const history = useNavigate();
    const handleDelete = async(id)=>{
        
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         let response = await fetch(API_URL+ `/api/affiliates/delete/${id}`, { 
           method: "DELETE",
           headers: headersList
         });
         let data = await response.json();
         if(data.message=="Data deleted successfully"){
            window.location.reload();
         }
      
       
      }
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'))
        const table = $('#dataTable').DataTable({
            pageLength: 10,
            responsive:true,
            data: jobsData,
            columns:
            [{ data: 'id' , width : 10},
            { data: 'business_name', width: 10 },
            { data: 'email' ,width: 10},
            { data: 'phone',width: 10 },
            { data: 'status', width: 10 },
            user.role === 'user' ? 

            {
                data: null, // Indicates this column is generated using the `render` function
                render: function (data, type, row) {
                  // Return HTML string for buttons
                  return `
                    <button class="btn btn-success view-btn" data-id="${row.id}">View</button>
                   
                  `;
                },
                title: 'Actions', // The header for the column
                orderable: false // Optional: Prevent sorting on this column
              }:
            {
                data: null, // Indicates this column is generated using the `render` function
                render: function (data, type, row) {
                  // Return HTML string for buttons
                  
                  return `
                  <div class="dropdown">
                  <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="ph ph-list"></i>
                  </button>
                  <ul class="dropdown-menu">
                  
                    <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Affiliate</a></li>
                    <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Affiliate</a></li>
                    <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Affiliate</a></li>
                  </ul>
                </div>
                   
                  `;
                },
                title: 'Actions', // The header for the column
                orderable: false // Optional: Prevent sorting on this column
              }
          ]
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
            const id = $(this).data('id');
            history(`/edit-affiliates/${id}`); // Navigate to the edit page
          });
        $('#dataTable tbody').on('click', '.view-btn', function () {
            const id = $(this).data('id');
            history(`/view-business-profile/${id}`); // Navigate to the edit page
          });
      
          // Event listener for delete button
          $('#dataTable tbody').on('click', '.delete-btn', function () {
            const id = $(this).data('id');
            handleDelete(id); // Call the delete function
          });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);
    return (
        <div className="card basic-data-table">
            <div className="card-header">
                <h5 className="card-title mb-0">{status === 'active' ? 'Active Sign Up Affiliates' : 'Sign Up Affiliates'}</h5>
            </div>
            <div className="card-body">
                <table
                    className="table bordered-table mb-0"
                    id="dataTable"
                    data-page-length={10}
                >
                    <thead>
                        <tr>
                            <th scope="col">
                                <div className="form-check style-check d-flex align-items-center">
                                    
                                    <label className="form-check-label">ID</label>
                                </div>
                            </th>
                            <th scope="col">Business Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* DataTables will populate this tbody */}
                    </tbody>
                </table>
            </div>
        </div>

    )
}

export default SignUpUserTable